import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import rules from '../../../../common/rules/rules';
import { translate } from 'react-i18next';
import { connectModal } from '../../../../features/modal/hoc';
import { apiCallIds } from '../../api';

const { TextArea } = Input;

@translate()
@Form.create()
@connectModal(apiCallIds.REJECT_ACCOUNT_DOCUMENTS)
export default class RejectDocumentsModal extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  handleSubmit = () => {
    const { form, onSubmit } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values.rejectReason);
      }
    });
  };

  render() {
    const { t, form, children, modalActions, isVisible, isLoading } = this.props;
    const { getFieldDecorator, resetFields } = form;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        <Modal
          title={t('Potvrdiť zamietnutie dokumentov')}
          okText={t('Zamietnuť')}
          visible={isVisible}
          confirmLoading={isLoading}
          onOk={this.handleSubmit}
          onCancel={modalActions.hide}
          afterClose={resetFields}
        >
          <Form>
            <Form.Item>
              {getFieldDecorator('rejectReason',{})(
                <TextArea
                  size="default"
                  placeholder={t('Dôvod zamietnutia dokumentov')}
                  autosize={{ minRows: 4, maxRows: 10 }}
                />
              )}
            </Form.Item>
          </Form>
        </Modal>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/account-management/components/documents/RejectDocumentsModal.js